import { Component } from "@angular/core";

@Component({
  selector: "box-header",
  templateUrl: "./box-header.component.html",
  styleUrls: ["./box-header.component.scss"],
})
export class BoxHeaderComponent {}
